var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.718,
    height: 24.135,
    viewBox: "0 0 20.718 24.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Paper-2",
    "data-name": "Paper",
    d: "M5.569,24.135A5.557,5.557,0,0,1,0,18.472V5.456A5.332,5.332,0,0,1,1.651,1.614,5.6,5.6,0,0,1,5.569.014h7.6a.92.92,0,0,1,.322,0h.159a.917.917,0,0,1,.657.28L20.463,6.7a.913.913,0,0,1,.255.632V18.472a5.631,5.631,0,0,1-5.442,5.663Zm0-22.3A3.734,3.734,0,0,0,1.823,5.456V18.472A3.881,3.881,0,0,0,2.9,21.2a3.689,3.689,0,0,0,2.667,1.109h9.707a3.528,3.528,0,0,0,2.539-1.149,3.972,3.972,0,0,0,1.08-2.691V8.484l-1.063,0-1.38,0a4.039,4.039,0,0,1-4.023-3.811l-.007-.229V1.836Zm8.676,2.609a2.216,2.216,0,0,0,2.211,2.216H17.9l-3.652-3.8Zm-7.7,12.937a.911.911,0,0,1-.124-1.814l.124-.008H13.1a.911.911,0,0,1,.124,1.814l-.124.008Zm0-6.016a.911.911,0,0,1-.124-1.814l.124-.009h4.078a.911.911,0,0,1,.124,1.814l-.124.009Z",
    transform: "translate(0 0)",
    fill: "#8fa2bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper1);
export default __webpack_public_path__ + "static/media/Paper1.c7ce847d31d88bc3d019b5d6ef32d4da.svg";
export { ForwardRef as ReactComponent };